import { availableInHoursMinutesOrDays } from "@faire/help-center-utils/lib/dateInTimeZone";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var FormattedAvailableTime = function FormattedAvailableTime(_ref) {
  var supportType = _ref.supportType,
    color = _ref.color;
  var _availableInHoursMinu = availableInHoursMinutesOrDays(supportType),
    time = _availableInHoursMinu.time,
    unit = _availableInHoursMinu.unit;
  var isLessThanOneHour = unit === "minutes";
  if (!time) {
    return null;
  }
  if (isLessThanOneHour) {
    return /*#__PURE__*/React.createElement(Typography, {
      color: color
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "F3qPNJ",
      defaultMessage: [{
        "offset": 0,
        "options": {
          "one": {
            "value": [{
              "type": 0,
              "value": "Available in "
            }, {
              "type": 7
            }, {
              "type": 0,
              "value": " min"
            }]
          },
          "other": {
            "value": [{
              "type": 0,
              "value": "Available in "
            }, {
              "type": 7
            }, {
              "type": 0,
              "value": " mins"
            }]
          }
        },
        "pluralType": "cardinal",
        "type": 6,
        "value": "availableMinTime"
      }],
      values: {
        availableMinTime: time
      }
    }));
  }
  if (unit === "hours") {
    return /*#__PURE__*/React.createElement(Typography, {
      color: color
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "jSjFuF",
      defaultMessage: [{
        "offset": 0,
        "options": {
          "one": {
            "value": [{
              "type": 0,
              "value": "Available in "
            }, {
              "type": 7
            }, {
              "type": 0,
              "value": " hour"
            }]
          },
          "other": {
            "value": [{
              "type": 0,
              "value": "Available in "
            }, {
              "type": 7
            }, {
              "type": 0,
              "value": " hours"
            }]
          }
        },
        "pluralType": "cardinal",
        "type": 6,
        "value": "availableHourTime"
      }],
      values: {
        availableHourTime: time
      }
    }));
  }
  return /*#__PURE__*/React.createElement(Typography, {
    color: color
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7WN4gS",
    defaultMessage: [{
      "offset": 0,
      "options": {
        "one": {
          "value": [{
            "type": 0,
            "value": "Available in "
          }, {
            "type": 7
          }, {
            "type": 0,
            "value": " day"
          }]
        },
        "other": {
          "value": [{
            "type": 0,
            "value": "Available in "
          }, {
            "type": 7
          }, {
            "type": 0,
            "value": " days"
          }]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "availableDayTime"
    }],
    values: {
      availableDayTime: time
    }
  }));
};